// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Light-DOM styles that MUST live in the host page's stylesheet, not inside
   the panel's shadow root. Two reasons a rule belongs here:
   1. It styles the host page itself (e.g., the body push-aside transition).
   2. It declares a CSS custom property on :root that the body rule reads.
      Custom properties on the shadow root cannot reach the host body. */
:root {
  --tp-panel-width: clamp(320px, 34vw, 520px);
}

body {
  transition: margin-right 280ms cubic-bezier(0.16, 1, 0.3, 1);
}

body.tp-panel-open {
  margin-right: var(--tp-panel-width);
}

@media (max-width: 480px) {
  body.tp-panel-open {
    margin-right: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/host-styles.css"],"names":[],"mappings":"AAAA;;;;wEAIwE;AACxE;EACE,2CAA2C;AAC7C;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Light-DOM styles that MUST live in the host page's stylesheet, not inside\n   the panel's shadow root. Two reasons a rule belongs here:\n   1. It styles the host page itself (e.g., the body push-aside transition).\n   2. It declares a CSS custom property on :root that the body rule reads.\n      Custom properties on the shadow root cannot reach the host body. */\n:root {\n  --tp-panel-width: clamp(320px, 34vw, 520px);\n}\n\nbody {\n  transition: margin-right 280ms cubic-bezier(0.16, 1, 0.3, 1);\n}\n\nbody.tp-panel-open {\n  margin-right: var(--tp-panel-width);\n}\n\n@media (max-width: 480px) {\n  body.tp-panel-open {\n    margin-right: 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
